import { Link } from 'react-router-dom';
import VideoHero from '@/components/promo/VideoHero';
import SepLine from '@/components/promo/SepLine';
import LetsTalk from '@/components/promo/LetsTalk';
import HtmlText from '@/components/promo/HtmlText';
import { useI18n } from '@/contexts/I18nContext';

const STATS = [
  {
    value: '51%',
    text: 'of marketers say that video content produces the best ROI.',
    source: 'syndacast.com',
  },
  {
    value: '71%',
    text: 'of consumers are more likely to make a purchase based on a social media reference.',
    source: 'alistdaily.com',
  },
  {
    value: '90%',
    text: 'of gamers rely on YouTube for gaming advice on a weekly basis.',
    source: 'findyourinfluence.com',
  },
  {
    value: '',
    text: '"In my opinion, nowhere is influencer marketing more influential than in the gaming industry."',
    source: 'forbes.com',
  },
  {
    value: '',
    text: '"Many games are turning to influencer marketing to increase launch awareness, product buzz, digital fans and sales."',
    source: 'findyourinfluence.com',
  },
  {
    value: '92%',
    text: 'of consumers trust recommendations from other people above all other ads, 83% take actions because of those recommendations.',
    source: 'business2community.com',
  },
];

const HOW_IT_WORKS_KEYS = ['1', '2', '3', '4', '5', '6'] as const;

export default function Advertisers() {
  const { t } = useI18n();

  return (
    <div id="games">
      {/* Hero */}
      <VideoHero videoSrc="/assets/videos/game.mp4" imageSrc="/assets/images/games.png">
        <h1>PLAY TO WIN</h1>
        <h2>
          CONNECT WITH OUR NETWORK OF INFLUENCERS<br />
          TO INCREASE YOUR BRAND ENGAGEMENT
        </h2>
        <SepLine />
        <div style={{ marginTop: 20, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 16 }}>
          <Link to="/contact" className="btn-gc">LET'S GET STARTED</Link>
          <a
            href="/downloads/company-profile"
            target="_blank"
            rel="noreferrer"
            style={{
              display: 'inline-block',
              padding: '10px 24px',
              border: '1px solid rgba(255,255,255,0.5)',
              borderRadius: 2,
              color: '#fff',
              fontSize: 13,
              letterSpacing: 2,
              textTransform: 'uppercase',
            }}
          >
            Company Profile &nbsp;<i className="fa fa-download" />
          </a>
        </div>
      </VideoHero>

      {/* Stats */}
      <div className="page-content" style={{ paddingBottom: 0 }}>
        <div style={{ maxWidth: 1100, margin: '0 auto', padding: '40px 20px' }}>
          <h3 style={{ textAlign: 'center', fontSize: 22, letterSpacing: 4, color: '#333', marginBottom: 30 }}>
            CONNECT WITH NEW AUDIENCES,<br />IMPROVE YOUR BRAND ENGAGEMENT
          </h3>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: 30, textAlign: 'center', margin: '40px 0' }}>
            {STATS.slice(0, 3).map((s, i) => (
              <div key={i}>
                {s.value && (
                  <div style={{ fontSize: 48, fontWeight: 700, color: 'var(--vivid-green)' }}>{s.value}</div>
                )}
                <p style={{ fontSize: 13, color: '#666', marginTop: 8, lineHeight: 1.6 }}>{s.text}</p>
                <p style={{ fontSize: 11, color: 'var(--vivid-green)' }}>{s.source}</p>
              </div>
            ))}
          </div>
        </div>

        <SepLine />

        {/* Global Reach */}
        <div style={{ maxWidth: 1100, margin: '0 auto', padding: '0 20px 40px' }}>
          <p style={{ textAlign: 'center', fontSize: 15, lineHeight: 1.8, color: '#555', maxWidth: 800, margin: '0 auto 30px' }}>
            We're connected to influencers on a global scale, with content creators residing in{' '}
            <b>North America</b>, <b>South America</b>, <b>Europe</b>, <b>South East Asia</b>,{' '}
            <b>Australia</b>, <b>Japan</b>, <b>Korea</b> and <b>the Middle East</b>.
          </p>

          <div
            style={{
              height: 400,
              background: '#505050',
              borderRadius: 4,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'rgba(255,255,255,0.5)',
              fontSize: 14,
              margin: '30px 0',
            }}
          >
            🌍 Global Network Map
          </div>
        </div>

        <SepLine />

        {/* How Can We Help */}
        <div style={{ maxWidth: 800, margin: '0 auto', padding: '0 20px 40px', textAlign: 'center' }}>
          <h3 style={{ fontSize: 22, letterSpacing: 4, color: '#333', marginBottom: 20 }}>
            HOW CAN WE HELP YOU ?
          </h3>
          <p style={{ fontSize: 15, lineHeight: 1.8, color: '#555' }}>
            {t('advertisers.howCanWeHelpYou.desc')}
          </p>
        </div>

        <SepLine />

        {/* How It Works */}
        <div style={{ maxWidth: 1100, margin: '0 auto', padding: '0 20px 40px' }}>
          <h3 style={{ textAlign: 'center', fontSize: 22, letterSpacing: 4, color: '#333', marginBottom: 10 }}>
            THIS IS HOW WE DO
          </h3>
          <SepLine invisible />

          <div className="grand-numbers">
            {HOW_IT_WORKS_KEYS.slice(0, 3).map((key, idx) => (
              <div className="grand-number-block" key={key}>
                <div className="grand-number">{idx + 1}</div>
                <div className="grand-number-content">
                  <HtmlText html={t(`advertisers.howItWorks.${key}`)} as="h4" />
                </div>
              </div>
            ))}
          </div>

          <div className="grand-numbers" style={{ marginTop: '2vw' }}>
            {HOW_IT_WORKS_KEYS.slice(3).map((key, idx) => (
              <div className="grand-number-block" key={key}>
                <div className="grand-number">{idx + 4}</div>
                <div className="grand-number-content">
                  <HtmlText html={t(`advertisers.howItWorks.${key}`)} as="h4" />
                </div>
              </div>
            ))}
          </div>
        </div>

        <LetsTalk />
      </div>
    </div>
  );
}
